import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles, TableHead, TableRow, TableCell } from "@material-ui/core";
import { notArrayOrEmpty } from '../../utils/helpers';
import guid from './../../utils/guid';

const useStyles = makeStyles(theme => ({
    cell: {
        padding: theme.spacing(1),
        fontSize: 14
    }
}));

const TableHeader = ({ data, align = "center" }) => {
    const classes = useStyles();
    const printTable = data => {
        if(notArrayOrEmpty(data))
            return;
        return data.map(element => {
            return (
                <TableCell
                    key={guid()}
                    className={classes.cell}
                    align={align}
                >
                    {element}
                </TableCell>
            );
        });
    };

    return (
        <TableHead>
            <TableRow>
                {printTable(data)}
            </TableRow>
        </TableHead>
    );
};

TableHeader.propTypes = {
    data: PropTypes.array.isRequired,
    align: PropTypes.string
};

export default TableHeader;
